export interface AuthState {
    authData: object;
    inProgress?: boolean;
    error?: any;
    authorized: boolean,
    isProgress: string,
    notify: boolean
 }
export enum GoogleAuthActionTypes {
    GET_GOOGLE_AUTH_DATA_REQUEST = 'GET_GOOGLE_AUTH_DATA_REQUEST',
    GET_GOOGLE_AUTH_DATA_SUCCESS = 'GET_GOOGLE_AUTH_DATA_SUCCESS',
    GET_GOOGLE_AUTH_DATA_ERROR = 'GET_GOOGLE_AUTH_DATA_ERROR',

    GET_PASSWORD_CHANGE_REQUEST =  'GET_PASSWORD_CHANGE_REQUEST',
    GET_PASSWORD_CHANGE_SUCCESS =  'GET_PASSWORD_CHANGE_SUCCESS',
    GET_PASSWORD_CHANGE_ERROR =  'GET_PASSWORD_CHANGE_ERROR',

    REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION',

    VERIFY_CHANGE_PASSWORD_REQUEST =  'VERIFY_CHANGE_PASSWORD_REQUEST',
    VERIFY_PASSWORD_CHANGE_SUCCESS =  'VERIFY_PASSWORD_CHANGE_SUCCESS',
    VERIFY_CHANGE_PASSWORD_ERROR =  'VERIFY_CHANGE_PASSWORD_ERROR',

    VERIFY_AUTHORIZATION_VALUE_REQUEST = 'VERIFY_AUTHORIZATION_VALUE_REQUEST',
    VERIFY_AUTHORIZATION_VALUE_SUCCESS = 'VERIFY_AUTHORIZATION_VALUE_SUCCESS',
    VERIFY_AUTHORIZATION_VALUE_ERROR = 'VERIFY_AUTHORIZATION_VALUE_ERROR'
}
interface GoogleAuthRequestAction {
    type: GoogleAuthActionTypes.GET_GOOGLE_AUTH_DATA_REQUEST
}
interface GoogleRemoveNotification {
    type: GoogleAuthActionTypes.REMOVE_NOTIFICATION
}
interface GoogleAuthSuccessAction {
    type: GoogleAuthActionTypes.GET_GOOGLE_AUTH_DATA_SUCCESS;
    payload: any;
}
interface GoogleAuthErrorAction {
    type: GoogleAuthActionTypes.GET_GOOGLE_AUTH_DATA_ERROR;
    error: any;
}

interface PasswordCahngeRequestAction {
    type: GoogleAuthActionTypes.GET_PASSWORD_CHANGE_REQUEST
}
interface PasswordCahngeSuccessAction {
    type: GoogleAuthActionTypes.GET_PASSWORD_CHANGE_SUCCESS;
    payload: any;
}
interface PasswordCahngeErrorAction {
    type: GoogleAuthActionTypes.GET_PASSWORD_CHANGE_ERROR;
    error: any;
}
interface VerifyPasswordChangeRequestAction {
    type: GoogleAuthActionTypes.VERIFY_CHANGE_PASSWORD_REQUEST
}
interface VerifyPasswordChangeSuccesstAction {
    type: GoogleAuthActionTypes.VERIFY_PASSWORD_CHANGE_SUCCESS;
    payload: any;
}
interface VerifyPasswordChangeErrorAction {
    type: GoogleAuthActionTypes.VERIFY_CHANGE_PASSWORD_ERROR;
    error: any;
}

interface VerifyAuthReqeustAction {
    type: GoogleAuthActionTypes.VERIFY_AUTHORIZATION_VALUE_REQUEST
}
interface VerifyAuthSuccessAction {
    type: GoogleAuthActionTypes.VERIFY_AUTHORIZATION_VALUE_SUCCESS;
    payload: any;
}
interface VerifyAuthErrorAction {
    type: GoogleAuthActionTypes.VERIFY_AUTHORIZATION_VALUE_ERROR;
    error: any;
}
export type GoogleAuthAction =
     GoogleAuthRequestAction |
     GoogleAuthSuccessAction |
     GoogleAuthErrorAction   |
     VerifyAuthReqeustAction |
     VerifyAuthSuccessAction |
     VerifyAuthErrorAction   |
     PasswordCahngeErrorAction|
     PasswordCahngeRequestAction|
     PasswordCahngeSuccessAction |
     VerifyPasswordChangeRequestAction | 
     VerifyPasswordChangeSuccesstAction | 
     VerifyPasswordChangeErrorAction     |
     GoogleRemoveNotification


